import React, { useState, useEffect } from 'react';
import { db } from 'src/config/firebase';
import { format } from 'date-fns-tz';
import { add ,parse } from 'date-fns';
import getIpAddress from 'src/config/GetIPAddress';
import { withTranslation } from 'react-i18next';
import { Box, IconButton, Backdrop, CircularProgress } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import withStyles from '@mui/styles/withStyles';
import { ArrowBackOutlined, ArrowForwardOutlined, DuoOutlined, LocationOnOutlined, LocationOffOutlined } from '@mui/icons-material';
import { theme } from '../../../Template3/Template';
import { useNavigate } from 'react-router-dom';
import Calendar from './components/Calendar';
import { formatDuration } from 'src/config/Utils';
import { addMinutes } from 'src/config/Utils';
import { AlertMessage } from 'src/screens/Partners/Service/components';
import '../../../shared/styles.css'

const ColorCircularProgress = withStyles({
    root: {
        color: '#0F467A',
        width:'50px !important',
        height:'50px !important',
        position: 'absolute',
    },
})(CircularProgress);

const useStyles = makeStyles(() => ({
    rootDiv:{
        width:'70%',
        minWidth:'60%',
        maxWidth:'70%',
        minHeight:'550px',
        borderRadius:'8px',
        backgroundColor:'rgba(255,255,255,1)',
        display:"flex",
        flexDirection:"column",
        alignItems:"center",
        margin:'auto',

        [theme.breakpoints.down('sm')]: {
            maxWidth:'100%',
            minWidth:'100%',
            width:'100%'
        }
    },

    rowDiv:{
        display:'flex',
        flexDirection:'row',
    },

    innDiv:{
        flex:'1 1 auto',
        width:'100%',
        [theme.breakpoints.down('sm')]: {
            padding:'20px 0px',
            flexDirection:'column'
        }
    },

    tp:{
        whiteSpace: 'pre-line',
        overflowWrap: 'break-word',
        wordBreak: 'break-word',
        fontFamily:"'Cairo', sans-serif"
    },

    playBtn:{
        position: 'absolute',
        margin: 'auto',
        width: '100%',
        height: '100%',
        cursor:'pointer',
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        justifyContent:'center',
    },

    playBtnWrapper:{
        width:'97px',
        height:'97px',

        '& img':{
            width:'100%',
            height:'100%'
        }
    },

    childDiv:{
        width:'50%',
        minWidth:'300px',
        borderRight:'1px solid rgba(26,26,26,0.1)',
        transition: 'all .22s ease-out',
        [theme.breakpoints.down('sm')]: {
            width:'100%',
            borderRight:'none',
            borderBottom: '1px solid rgba(26,26,26,0.1)'
        }
    },

    childDiv2:{
        width:'50%',
        flex:'1 1 50%',
        transition: 'all .22s ease-out',
        position:'relative',
        [theme.breakpoints.down('sm')]: {
            width:'100%'
        }
    },


    headSpan:{
        fontSize:'23px',
        fontWeight: 'bold',
        [theme.breakpoints.down('sm')]: {
            fontSize:'20px'            
        }
    },

    marLf:{
        marginLeft:'10px'
    },

    marRg:{
        marginRight:'10px'
    },

    marLf30:{
        marginLeft:'30px'
    },

    marRg30:{
        marginRight:'30px'
    },

    durTitle:{
        color: 'rgba(26,26,26,0.61)',
        fontWeight:'bold'
    },

    backBtn:props=> ({
        color: props.buttonColor ? props.buttonColor : props.calendarBg ? props.calendarBg : 'rgb(0,105,255)',
        border:'1px solid rgba(26,26,26,0.1)',
        backgroundColor: props.calendarBgHover ? props.calendarBgHover : '#fff',
        fontSize:'24px',
        cursor:'pointer',
        "&:hover": {
            backgroundColor: props.buttonColor ? props.buttonColor : props.calendarBgHover ? props.calendarBgHover : "rgba(0,105,255,0.15)",
            color: props.buttonFontColor ? props.buttonFontColor : props.calendarBg ? props.calendarBg : 'rgb(0,105,255)',
        },
    }),

    backdrop: {
        zIndex: 111125,
        color: '#fff',
        position:'absolute',
        backgroundColor:'rgba(0,0,0,0.2)'
    },
}));

const AppointmentBook = (props) => {
    const { contentData, schedule, data, fontFamily, customCls, calendarBg, calendarBgHover, calendarColor, t, viewType, rescheduleBooking } = props;
    const scheduleId = schedule && schedule.id || '';

    const [loading,setLoading] = useState(false);
    const [timeslotloading,setTimeslotloading] = useState(false);
    const [selectedDate,setSelectedDate] = useState(null);
    const [showCalendar,setShowCalendar] = useState(true);
    const [selectedTime,setSelectedTime] = useState('');
    const [partnerSelectedTime,setPartnerSelectedTime] = useState('');
    const [showTime,setShowTime] = useState(false);
    const [timeSlots,setTimeSlots] = useState([]);
    const [userTimezone, setUserTimezone] = useState('');

    const [message,setMessage] = useState('');
    const [alertType,setAlertType] = useState('');
    const [open,setOpen] = useState(false);

    const navigate = useNavigate();
    const { isRTL, companyData, themeDesign, buttonColor, buttonFontColor } = data || {};
    const calendarHover = buttonColor ? hexToRgba(buttonColor) : calendarBgHover;
    const classes = useStyles({calendarBg,calendarBgHover:calendarHover,calendarColor,buttonColor,buttonFontColor});
    
    const marginClass = isRTL === 'ar' ? classes.marLf : classes.marRg;
    const marginClass30 = isRTL === 'ar' ? classes.marLf30 : classes.marRg30;

    useEffect(()=>{
        async function getIpAddressData() {
            const data = await getIpAddress();
            if(data) {
                const timezone = data['time_zone']?.['name'] || '';
                setUserTimezone(timezone);
            }
        };

        getIpAddressData();

    },[])


    const getBookedTimeslot = async (date,maxAttendance) => {
        let list = [];
        let newList = [];
        const res = await (await db.ref(`Reservations/`).orderByChild('scheduleId').equalTo(scheduleId).once('value')).val();
        if(res && Object.keys(res)) {
            Object.values(res).forEach(v=> {
                if(v.appointmentDateString === date && !['notShow','declined']?.includes(v.status)) list.push(v.parTzTimeslot);
            });
        };

        if(list?.length && maxAttendance) {
            newList = checkMaxAttendance(list,maxAttendance);
        }
        return newList?.length ? newList : list;
    };

    const { duration } = schedule || {};

    const selectDateEvent_ = async (date) => {
        let slots = [], list = [];
        setSelectedDate(date);
        setShowCalendar(false);
        setShowTime(true);
        setTimeslotloading(true);

        // get day
        const day = new Date(date).getDay();
        // convert selected date to 'YYYY, MM, DD' string
        const dateString = `${new Date(date).getFullYear()}, ${new Date(date).getMonth()}, ${new Date(date).getDate()}`;
        // timeList array of object
        const timeList = schedule['weeklyHours'][day]['timeLists'];

        // create time slot array from timeList
        for(var i in timeList) {
            var startTime = timeList[i].start;
            var endTime = timeList[i].end;
        
            var start_time = parseTime(startTime);
            var end_time = parseTime(endTime);

            slots.push(...calculate_time_slot( start_time, end_time, schedule['duration'] ));
        };
        
        // already booked time slot for selected date
        if(schedule['maxAttendance']) {
            list = await getBookedTimeslot(dateString,schedule['maxAttendance']);
        };

        // remove already booked time slot from time slot list
        const finalSlot = slots.filter( ( el ) => !list.includes( el ) );

        setTimeSlots(finalSlot);
        setTimeslotloading(false);
    };

    const selectDateEvent = async (date) => {
        let list = [];
        setSelectedDate(date);
        setShowCalendar(false);
        setShowTime(true);
        setTimeslotloading(true);

        // get day
        const day = new Date(date).getDay();
        // convert selected date to 'YYYY, MM, DD' string
        const dateString = `${new Date(date).getFullYear()}, ${new Date(date).getMonth()}, ${new Date(date).getDate()}`;
        // timeList array of object
        const timeList = schedule?.['weeklyHours']?.[day]?.['timeLists'] || [];
        const originalTimeZone = schedule['timezone'];
        const displayTimeZone = userTimezone;
    
        const dateObject = new Date(date);
        const generatedTimeSlots = [];
        const duration = schedule['duration'];
        const _date = format(date, 'yyyy-MM-dd');

        const formattedDate = format(date, 'yyyy-MM-dd');

        const timeZoneDifference = getTimezoneOffset(date, displayTimeZone) - getTimezoneOffset(date, originalTimeZone);

        timeList.forEach(({ start, end }) => {
            const startTime = parse(`${formattedDate} ${start}`, 'yyyy-MM-dd HH:mm', new Date(), { timeZone: originalTimeZone });
            const endTime = parse(`${formattedDate} ${end}`, 'yyyy-MM-dd HH:mm', new Date(), { timeZone: originalTimeZone });
        
            let currentDateTime = startTime;
        
            while (currentDateTime < endTime) {
              // Check if the current time slot is not expired
              if (currentDateTime > new Date()) {
                const parFormattedTime = format(currentDateTime, 'HH:mm');
                const formattedTime = format(add(currentDateTime, { minutes: timeZoneDifference }), 'HH:mm', { timeZone: displayTimeZone });
                generatedTimeSlots.push({time:formattedTime,partnerTime:parFormattedTime});
              }
        
              currentDateTime = add(currentDateTime, { minutes: duration });
            }
        });

        // already booked time slot for selected date
        if(schedule['maxAttendance']) {
            list = await getBookedTimeslot(dateString,schedule['maxAttendance']);
        };

        // remove already booked time slot from time slot list
        const finalSlot = generatedTimeSlots.filter( ( el ) => !list.includes( el['partnerTime'] ) );
        setTimeSlots(finalSlot);
        setTimeslotloading(false);
    };

    const getTimezoneOffset = (date, timeZone) => {
        const offsetInMilliseconds = Date.parse(new Date(date.toLocaleString('en-US', { timeZone })));
        return offsetInMilliseconds / 60000;
    };

    const selectTimeEvent = (time,partnerTime) => {
        setSelectedTime(time);
        setPartnerSelectedTime(partnerTime);
    };

    const backEvent = () => {
        setShowCalendar(true);
        setShowTime(false);
        setSelectedTime('');
        setPartnerSelectedTime('');
    };

    const showAlert = (message,alertType) => {
        setMessage(message);
        setAlertType(alertType);
        setOpen(true);
    };

    const closeAlert = () => {
        setMessage('');
        setAlertType('');
        setOpen(false);
    };

    const confirmEvent = () => {
        const dateStamp = new Date(selectedDate).getTime();
        const parTz = schedule['timezone'];
        if(!scheduleId) {
            showAlert('Select sechdule','error')
        }
        else if(!partnerSelectedTime || !selectedTime) {
            showAlert('Select time to continue','error');
        }
        else if(!parTz) {
            showAlert('No timezone found of company','error');
        }
        else if(!userTimezone) {
            showAlert('No timezone found of user','error');
        }
        else{
            if(viewType === 'dashboard') {
                const duration = schedule?.duration || '';
                const appointmentDate = Math.floor(dateStamp/1000);
                const appointmentDateString = `${new Date(Number(dateStamp)).getFullYear()}, ${new Date(Number(dateStamp)).getMonth()}, ${new Date(Number(dateStamp)).getDate()}`;  
                const parTzTimeslot =  partnerSelectedTime || '';
                const parTzTimeslotEnd = addMinutes(partnerSelectedTime,duration);
                const userTzTimeslot = selectedTime || '';
                const userTzTimeslotEnd = addMinutes(selectedTime,duration);
                const userTz = userTimezone ? userTimezone?.replace("-","/") : '';
                const _parTz = parTz ? parTz?.replace("-","/") : '';
                console.log('duration',duration)
                console.log('appointmentDate',appointmentDate);
                console.log('appointmentDateString',appointmentDateString);
                console.log('parTzTimeslot',parTzTimeslot);
                console.log('parTzTimeslotEnd',parTzTimeslotEnd);
                console.log('userTzTimeslot',userTzTimeslot);
                console.log('userTzTimeslotEnd',userTzTimeslotEnd);
                console.log('userTz',userTz);
                console.log('parTz',_parTz);
                rescheduleBooking(duration,appointmentDate,appointmentDateString,parTzTimeslot,parTzTimeslotEnd,userTzTimeslot,userTzTimeslotEnd,userTz,_parTz);
            }
            else{
                navigate(`/schedule-booking/${scheduleId}/${dateStamp}/${partnerSelectedTime}/${selectedTime}/${parTz?.replace("/","-")}/${userTimezone.replace("/","-")}`);
            }
        }
    };

    const locationIcon = {
        'Online video Conference': <DuoOutlined className={`${marginClass}`} style={{color:'rgba(26,26,26,0.61)'}}/>,
        'Physical address': <LocationOnOutlined className={`${marginClass}`} style={{color:'rgba(26,26,26,0.61)'}}/>,
        'No location': <LocationOffOutlined className={`${marginClass}`} style={{color:'rgba(26,26,26,0.61)'}}/>,
    };

    return (
        (<Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            className={`${classes.rootDiv} ${customCls || ''}`}
        >
            <div className={`${classes.rowDiv} ${classes.innDiv}`}>
                <div className={classes.childDiv2}>
                    <div className={classes.rowDiv} style={{alignItems:'center',padding:'20px 20px 20px 20px'}}>
                        {showTime ?
                        <IconButton
                            className={`${marginClass30} ${classes.backBtn}`}
                            onClick={backEvent}
                            size="large">
                            {isRTL === 'ar' ? <ArrowForwardOutlined style={{fontSize:'2rem'}}/> : <ArrowBackOutlined style={{fontSize:'2rem'}}/>}
                        </IconButton>
                        : null}
                        <p className={classes.headSpan} style={{fontFamily:fontFamily}}>{showCalendar ? t && t('services.sh-section.selectDate') : showTime ? t && t('services.sh-section.selectTime') : ''}</p>
                    </div>
                    <Calendar 
                        {...{
                            schedule: schedule || {},
                            timeSlots: timeSlots || [],
                            selectedDate,
                            selectDateEvent, 
                            showCalendar, 
                            selectedTime,
                            selectTimeEvent,
                            showTime,
                            backEvent,
                            confirmEvent,
                            fontFamily,
                            timeslotloading,
                            t,
                            userTimezone,
                            marginClass,
                            calendarBg: buttonColor || calendarBg,
                            calendarBgHover: calendarHover,
                            calendarColor: buttonFontColor || calendarColor,
                            data
                        }}
                    />

                    <Backdrop className={classes.backdrop} open={loading || timeslotloading}>
                        <ColorCircularProgress />
                    </Backdrop>
                </div>
            </div>
            <AlertMessage
                {...{
                    alertType,message,snackOpen:open,closeAlert: closeAlert
                }}
            />
        </Box>)
    );
};

export default withTranslation('common')(AppointmentBook);

function parseTime(s) {
    var c = s.split(':');
    return parseInt(c[0]) * 60 + parseInt(c[1]);
}
function convertHours(mins){
    var hour = Math.floor(mins/60);
    var mins = mins%60;
    var converted = pad(hour, 2)+':'+pad(mins, 2);
    return converted;
}
function pad (str, max) {
    str = str.toString();
    return str.length < max ? pad("0" + str, max) : str;
}
function calculate_time_slot(start_time, end_time, interval){
      var i, formatted_time;
    var time_slots = new Array();
      for(var i=start_time; i<=end_time; i = i+interval){
      formatted_time = convertHours(i);
      time_slots.push(formatted_time);
    }
    return time_slots;
}

function checkMaxAttendance(list,maxAttendance) {
    let newList = [];
    var obj = {};

    list.forEach(function (x) { obj[x] = {value: x, total: Number(Number(obj[x]?.['total'] || 0) + 1) }});
    Object.values(obj).filter(val=> {
        if(val['total'] >= maxAttendance) {
            newList.push(val['value'])
        };
    });

    return newList;
}

export function SideInfo({icon,text,fontFamily,titleCustomCls}) {
    const classes = useStyles();
    return(
        <div className={classes.rowDiv} style={{alignItems:'center',padding:'20px',paddingTop:'0px'}}>
            {icon}
            <span className={`${classes.durTitle} ${titleCustomCls || ''}`} style={{fontFamily}}>{text}</span>
        </div>
    );
}

function hexToRgba(hex) {
    const normalizeHex = hex.replace('#', '');
    const r = parseInt(normalizeHex.substring(0, 2), 16);
    const g = parseInt(normalizeHex.substring(2, 4), 16);
    const b = parseInt(normalizeHex.substring(4, 6), 16);
    const a = normalizeHex.length === 8 
      ? parseInt(normalizeHex.substring(6, 8), 16) / 255 
      : 1; // Default alpha to 1 if not provided
  
    return { r, g, b, a };
}  
 